import { initCalendarMailboxConfiguration } from 'owa-calendar-configuration';
import { trace } from 'owa-trace';

export default async function loadCalendarMailboxConfiguration(): Promise<boolean> {
    try {
        await initCalendarMailboxConfiguration();
        return true;
    } catch (e) {
        trace.warn(e.message || 'loadCalendarMailboxConfiguration failed');
        return false;
    }
}
